let navigateFunction = null;
export const setNavigate = (navigate) => {
  navigateFunction = navigate;
};
export const navigateToLogin = () => {
  // Clear any pending secondary-link flags on forced navigation to login
  try {
    localStorage.removeItem('pendingSecondaryLink');
    localStorage.removeItem('pendingSecondaryLinkReturn');
  } catch (_) {
    // ignore
  }
  if (navigateFunction) {
    navigateFunction('/login', { replace: true });
  } else {
    window.location.href = '/login';
  }
};
